import { render, staticRenderFns } from "./ManageRegistration.vue?vue&type=template&id=110f507c&scoped=true"
import script from "./ManageRegistration.vue?vue&type=script&lang=js"
export * from "./ManageRegistration.vue?vue&type=script&lang=js"
import style0 from "./ManageRegistration.vue?vue&type=style&index=0&id=110f507c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110f507c",
  null
  
)

export default component.exports